<app-common-dropdown
    [formCtrl]="formCtrl"
    [label]="label || 'Выбрать исполнителя'"
    [service]="personSelectorService"
    [disabled]="disabled"
    data-testid="app-dropdown-person-selector"
></app-common-dropdown>
